<script>
  import { getContext } from "svelte";
  import { GridContainer, Video } from "@ObamaFoundation/of-design-system";

  /** @type { string } */
  let className = "";
  export { className as class };
  export let header;
  export let body;
  export let videoUrl;
  export let videoId = undefined;
  export let caption = undefined;
  export let videoCoverImage = undefined;
  export let loopSection = undefined;
  export let startTime = 0;

  const isContainerized = !!getContext("containerized");
</script>

{#if isContainerized}
  <Video
    {header}
    {body}
    {videoCoverImage}
    {videoUrl}
    {videoId}
    {caption}
    {loopSection}
    {startTime}
    class={className}
  />
{:else}
  <GridContainer containerClass={className}>
    <Video
      {header}
      {body}
      {videoCoverImage}
      {videoUrl}
      {videoId}
      {caption}
      {loopSection}
      {startTime}
      class={className}
    />
  </GridContainer>
{/if}
